import { gql } from "@apollo/client";

/**
 * The effective permission codes of the signed-in user.
 *
 * This is the single source of truth for what the current user may do. The backend is
 * expected to return the already-resolved list (including any wildcards such as
 * `Hotels:*` or `*`); the client does not derive permissions from roles.
 */
export const GET_MY_PERMISSIONS = gql`
  query MyPermissions {
    myPermissions
  }
`;
